module.exports = __webpack_public_path__ + "img/6-01.0eff9bf1.png";